import { React } from "react";

// project-imports
import StencilBox from "../stencils/StencilBox";


const PostYouTubeVideoStencil = ({ classes }) => {

    return (
        <div className={`edu-card card-type-2 radius-small ${classes ? classes : ''}`}>
            <div className="inner">
                <div className="thumbnail">
                    <StencilBox
                        className="sf-img-stencil"
                        width="335px"
                        height="190px"
                        backgroundColor="#F5F5F5"
                    />
                    <div className="top-position status-group left-top">
                    </div>

                </div>
                <div className="content">
                    <ul className="edu-meta meta-01 mt--20">
                        <li>
                            <StencilBox
                                width="109px"
                                height="26px"
                                backgroundColor="#F5F5F5"
                            />
                        </li>
                        <li>
                            <StencilBox
                                width="106px"
                                height="26px"
                                backgroundColor="#F5F5F5"
                            />
                        </li>
                    </ul>
                    <div className="cl-lg-12 d-flex justify-content-center edu-rating rating-default mt--10">
                        <StencilBox
                            width="100%"
                            height="44px"
                            backgroundColor="#F5F5F5"
                        />
                    </div>
                    <ul className="edu-meta meta-01 mt--20">
                        <li>
                            <StencilBox
                                width="109px"
                                height="26px"
                                backgroundColor="#F5F5F5"
                            />
                        </li>
                        <li>
                            <StencilBox
                                width="106px"
                                height="26px"
                                backgroundColor="#F5F5F5"
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default PostYouTubeVideoStencil;
